import api from './api';
import type { CredentialType } from '@/types/credentialType';

export const credentialTypeApi = {
  getAll: async (includeInactive = false): Promise<CredentialType[]> => {
    const response = await api.get<CredentialType[]>('/credential-types', {
      params: includeInactive ? { includeInactive: true } : undefined,
    });
    return response.data;
  },

  getById: async (id: number): Promise<CredentialType> => {
    const response = await api.get<CredentialType>(`/credential-types/${id}`);
    return response.data;
  },

  getByCode: async (code: string): Promise<CredentialType> => {
    const response = await api.get<CredentialType>(`/credential-types/code/${encodeURIComponent(code)}`);
    return response.data;
  },
};
